module.exports = __webpack_public_path__ + "static/media/18ECA34.a9d35869.jpg";